export const STATUS_TYPES_COLORS = [
  { type: "drafted", color: "#999999" },
  { type: "produced", color: "#609cb3" },
  { type: "accepted", color: "#5ae000" },
  { type: "annulled", color: "#bf0010" },
  { type: "refused", color: "#a2258a" },
  { type: "validated", color: "#58b519" },
  { type: "expired", color: "#ff5719" },
  { type: "to_be_paid", color: "#ffb44d" },
  { type: "partially_paid", color: "#f08e05" },
  { type: "paid", color: "#339648" },
  { type: "overdue", color: "#ff0014" },
  { type: "unrecoverable", color: "#574e9c" },
];

export const checkStatusTypeColor = (type: string) => {
  return STATUS_TYPES_COLORS.find(item => item.type === type)?.color;
};
